module.exports = __webpack_public_path__ + "img/jms.698369c5.png";